var map = {
	"./cockpit-color-icon.png": 8257,
	"./goodin-color-icon.png": 3841,
	"./goodin-icon.png": 7482,
	"./hub-color-icon.png": 5485,
	"./hub-icon.png": 713,
	"./keepup-color-icon.png": 5922,
	"./keepup-icon.png": 1894,
	"./knowlake-color-icon.png": 1049,
	"./knowlake-icon.png": 4522,
	"./ksm-color-icon.png": 7568,
	"./lab-icon.png": 25,
	"./lib-icon.png": 5734,
	"./logicprint5-color-icon.png": 767,
	"./logicprint5-icon.png": 6085,
	"./logicprint7-color-icon.png": 2692,
	"./logicprint7-icon.png": 7527,
	"./packos-color-icon.png": 7480,
	"./packos-icon.png": 5487,
	"./workboost-color-icon.png": 2311,
	"./workboost-icon.png": 2656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4185;